import React from 'react';
import { motion } from 'framer-motion';

function NotFound() {
  return (
    <section className="relative flex min-h-screen items-center justify-center overflow-hidden bg-paper px-5 text-ink">
      <div className="pointer-events-none absolute inset-0 -z-10">
        <span className="absolute -left-16 top-[10%] font-display text-[42vw] font-bold uppercase leading-none tracking-[-0.06em] text-ink/[0.04] md:text-[28vw]">
          404
        </span>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="relative z-10 max-w-2xl text-center"
      >
        <p className="meta-label">Error / Stray Route</p>
        <h1 className="mt-6 font-display text-6xl font-bold uppercase leading-[0.86] tracking-[-0.03em] md:text-8xl">
          Lost in the
          <br />
          <span className="italic text-transparent [-webkit-text-stroke:1.2px_rgba(16,16,16,0.45)]">Pixels.</span>
        </h1>
        <p className="copy-refined mx-auto mt-8 max-w-md text-sm text-ink/72 md:text-base">
          This page does not exist — maybe it was renamed, moved, or never built. Let&apos;s get you back to the
          good stuff.
        </p>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
          <a
            href="/"
            className="ui-button-dark inline-flex items-center gap-2 rounded-full border border-ink bg-coal px-6 py-3 text-[11px] font-semibold uppercase tracking-[0.18em] text-white"
          >
            Back to portfolio
            <span className="ui-arrow-hover text-accent">↗</span>
          </a>
          <a
            href="/#contact"
            className="ui-button-light inline-flex items-center gap-2 rounded-full border border-ink/25 px-6 py-3 text-[11px] font-semibold uppercase tracking-[0.18em] text-ink"
          >
            Say hello
          </a>
        </div>
      </motion.div>
    </section>
  );
}

export default NotFound;
